import { render, staticRenderFns } from "./PayRange.vue?vue&type=template&id=52b50512&scoped=true&"
import script from "./PayRange.vue?vue&type=script&lang=js&"
export * from "./PayRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b50512",
  null
  
)

export default component.exports